// extracted by mini-css-extract-plugin
export default {"scrollIcon":"styles_scrollIcon__-Q8lw"};